import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import CommentMainItem from '../aelComponent/CommentMainItem'

const Comment = props => {
  const {
    comments,
    clickToComment,
    likeComment,
    total,
    type,
    toSecondComment,
    commentType,
    changeCommentType,
    notShowCommentType
  } = props
  return (
    <div>
      <div className='CommentBox'>
        {
          type !== 'secondPageList' && <div className='recommendTitleBox' style={(type === 'pageList') ? { marginTop: '10px' } : null}>
            <span className='spot'></span>
            <span className='spot'></span>
            <h2 className='recommendTitle'>{comments?.length ? '文章评论' : '有沙发，还不抢一下？'}</h2>
            <span className='spot spot3'></span>
            <span className='spot'></span>
          </div>
        }
        {
          !notShowCommentType && comments && comments.length > 1 ?
            (
              <div className='comment_type'>
                <div className={commentType === 'postedAt' ? 'comment_item comment_item_current' : 'comment_item'} onClick={e => { changeCommentType('postedAt') }}>最新评论</div>
                <div className={commentType === 'likes' ? 'comment_item comment_item_current' : 'comment_item'} onClick={e => { props.changeCommentType('likes') }}>最热评论</div>
              </div>
            ) : null
        }
        <div className='commentList'>
          {
            comments?.length ? comments.map((item, index) => {
              return (
                <CommentMainItem
                  type={type}
                  likeComment={likeComment}
                  index={index}
                  commentItem={item}
                  key={'commentItem' + index}
                  clickToComment={clickToComment} 
                  toSecondComment={toSecondComment}
                ></CommentMainItem>
              )
            }) : null
          }
        </div>
      </div>
      {
        type !== 'secondPageList' && <div className='noMore'>
          <div className='recommendTitleBox'>
            <span className='spot'></span>
            <span className='spot'></span>
            <span className='recommendTitle'>{(comments && (comments.length >= total)) ? '没有更多了呦～' : '下拉加载更多～'}</span>
            <span className='spot spot3'></span>
            <span className='spot'></span>
          </div>
        </div>
      }
    </div>
  )
}

Comment.propTypes = {
  comments: PropTypes.array,
  clickToComment: PropTypes.func,
  likeComment: PropTypes.func,
  total: PropTypes.number,
  type: PropTypes.string,
  toSecondComment: PropTypes.func
}

export default Comment